module.exports = __webpack_public_path__ + "static/media/home-banner-nick.dfca29ab.png";